import React, { Component } from 'react';
import MobileProvider from './MobileProvider';
import OtherProvidersMobileTable from './OtherProvidersMobileTable';

class MobileProvidersTable extends Component {
    constructor(props) {
        super(props)
        this.state =
            {
                hasListings: false,
                providers: []
            }
        this.displayProvider = this.displayProvider.bind(this);
        this.sortData = this.sortData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let data = nextProps.data;
        let length = data.length;
        let allProviders = [];
        let currentProvArr = [];
        let currentProv = "";
        for (let i = 0; i < length; i++) {
            let current = data[i].name;
            if (current !== currentProv && currentProv !== "") {
                allProviders.push(currentProvArr);
                currentProvArr = [];
            }
            currentProv = current;
            currentProvArr.push(data[i]);
        }

        if (currentProvArr.length > 0) {
            allProviders.push(currentProvArr);
        }

        let order = this.checkOrder()
        this.setState(
            {
                hasListings: true,
                providers: allProviders,
                order: order
            }
        )
    }

    checkOrder() {
        let order = [];
        switch (this.props.channel) {
            case "hmm":
                order = ["Mystery", "Channel", "Family"];
                break;
            case "hd":
                order = ["Family", "Channel", "Mystery"];
                break;
            default:
                order = ["Channel", "Mystery", "Family"];
        }

        return order;
    }

    displayProvider(mvpd, i) {
        let operator = mvpd[0].operator;
		// let name = mvpd[0].name;
        let sortedMvpd = this.sortData(mvpd);
        return (
        <MobileProvider key={i} operator={operator} mvpd={sortedMvpd} order={this.state.order} />)
        // <MobileProvider key={i} name={name} mvpd={sortedMvpd} order={this.state.order} />)

    }


    sortData(mvpd) {
        let order = this.state.order;
        let length = mvpd.length;
        let sorted = [{}, {}, {}];
        for (let i = 0; i < length; i++) {
            let current = mvpd[i];
            let channel;
            if (current.channelName.indexOf(order[0]) > -1) {
                channel = 0;
            }
            else if (current.channelName.indexOf(order[1]) > -1) {
                channel = 1;
            }
            else if (current.channelName.indexOf(order[2]) > -1) {
                channel = 2;
            }


            if (current.channelName.indexOf("HD") > -1) {
                sorted[channel].HD = current; 
            } else {
                sorted[channel].SD = current;
                let existing;
                let duplicate;
                if (sorted[channel].SD)
                {
                               existing = parseInt(sorted[channel].SD.channelNumber, 10);
                	duplicate = parseInt(current.channelNumber, 10);
                	if (duplicate > existing)
                	{	
                		sorted[channel].HD = current;
                	}
                }

                if (!sorted[channel].SD)
                {
                	sorted[channel].SD = current;
                } 
            }
        }
        return sorted;
    }
    render() {
        if (this.state.hasListings && this.state.providers.length > 0) {
            return (
            <div className="small-devices">
                <div className="table-border">
                    {this.state.providers.map(this.displayProvider)}
                    <OtherProvidersMobileTable channel={this.props.channel} order={this.state.order} />
                </div>
            </div>
            )
        }
        else if (this.state.hasListings) {
            return (
            <div className="small-devices">
                <OtherProvidersMobileTable channel={this.props.channel} order={this.state.order} />
            </div>
            )
        }

        return (
        <div className="small-devices">

        </div>
        )
    }
}

export default MobileProvidersTable;


// WEBPACK FOOTER //
// ./src/components/MobileProvidersTable.js